import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';

import { ReactivateBtnComponent } from './reactivate-btn.component';

@NgModule({
  imports: [IonicModule],
  declarations: [ReactivateBtnComponent],
  exports: [ReactivateBtnComponent],
})
export class ReactivateBtnModule {}
